module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("HMP Isle of Wight – Parkhurst")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Clissold Rd")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Newport")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltsa_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("My darling girl,")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I woke in the night from a dream of you; so vivid that, for a few sleep-drugged seconds, I thought you were there beside me. I opened my eyes before the disappointment could bite too hard and found the room filled with a pale, eerie light.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I got up and walked to the window, remembering how oddly excited my dog would become on certain nights. I’d follow her downstairs, through a house filled with a strange, silver glow, and out into the garden to discover no hovering alien spaceship, just the full moon. She never had any pressing need to go out (I won’t lower the tone by reference to canine bodily functions), she just wanted to lie in the light of the moon and watch the stars. So the two of us did it together.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I stood at my window last night, watching the moon, thinking of the dog that I love, and the woman I love, and was filled with a sense of time stretching out endlessly, that this small cell-room will be my world for all eternity, that even when I die, my hell will take this form, and the shit-stained walls and phlegm-polluted food will go on, and the remembrance of you will become like a dying star, just a memory of light that makes the darkness unbearable.")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "lti_1"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Hamish")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "sptni"
  }, [_vm._v("PROPERTY OF AVON AND SOMERSET POLICE. Ref: 544/45.2 Hamish Wolfe.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f2e68b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 90
// module chunks = 0